<template>
	<img
		v-if="url && !isDamaged"
		class="flex-none rounded-full"
		:style="style"
		:src="url"
		:alt="`User avatar ${name}`"
		@error.prevent="isDamaged = true"
	/>
	<div v-else-if="name" class="bg-gray-600 flex-none p-4 rounded-full" :style="style">
		<svg :viewBox="`0 0 ${size} ${size}`">
			<text
				x="50%"
				y="50%"
				dominant-baseline="middle"
				text-anchor="middle"
				class="font-bold"
				fill="var(--gray-100)"
			>
				{{ uppercasedInitials }}
			</text>
		</svg>
	</div>
	<BaseIcon
		v-else
		name="anonymous"
		class="flex-none rounded-full"
		:style="{width: `${size}px`, height: `${size}px`}"
	/>
</template>

<script>
export default {
	name: 'BaseUserAvatar',
	props: {
		url: {type: String, default: ''},
		name: {type: String, default: ''},
		size: {type: [Number, String], default: 18},
	},
	data() {
		return {
			isDamaged: false,
		}
	},
	computed: {
		style() {
			return {
				height: `${this.size}px`,
				width: `${this.size}px`,
			}
		},
		uppercasedInitials() {
			if (!this.name) return ''
			const names = this.name.split(' ')
			const initials =
				names.length > 1
					? names
							.map(name => name[0])
							.slice(0, 2)
							.join('')
					: names[0].slice(0, 2)
			return initials.toUpperCase()
		},
	},
}
</script>
